<template>
  <MainLayout>
    <div class="parallax" data-parallax data-parallax-speed="0.25" data-parallax-direction="down">
      <div class="relative w-screen">
        <img
          class="absolute -left-[1vw] top-[-12vh] w-[20vw] opacity-80"
          src="/images/bg-visual-left-top.webp"
          alt="" />
        <img
          class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60"
          src="/images/bg-visual-right-top.webp"
          alt="" />
      </div>
    </div>

    <section id="hero" :lang="locale" class="max-w-[1080px] lg:m-[auto] hyphens-auto break-words">
      <div class="flex items-center lg:mt-[4rem] lg:-mb-[5rem]">
        <div class="flex flex-col gap-y-4.5 lg:gap-y-8 min-w-0">
          <h1
            class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px] font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.avg.title') }}
          </h1>
          <p class="text-center leading-[27px] lg:text-lg font-semibold text-lighter">
            {{ t('pages.avg.subtitle') }}
          </p>
        </div>
      </div>
    </section>

    <section id="avg" :lang="locale" class="max-md:-mt-10 hyphens-auto break-words">
      <div
        class="w-full max-w-[800px] mb-16 lg:mb-24 bg-white rounded-3xl p-8 lg:p-12 shadow-sm border border-[#ECEDF0]">
        <div class="flex flex-col gap-y-10 text-lighter leading-relaxed">
          <div v-for="section in sections" :key="section.title" class="flex flex-col gap-y-4">
            <h2 class="text-xl lg:text-2xl font-bold text-dark">{{ section.title }}</h2>

            <template v-for="(block, index) in section.blocks" :key="index">
              <p v-if="block.type === 'paragraph'">{{ block.text }}</p>
              <p v-else-if="block.type === 'definition'">
                <strong class="text-dark">{{ block.term }}:</strong> {{ block.text }}
              </p>
              <ul v-else class="list-disc pl-6 flex flex-col gap-y-1">
                <li v-for="item in block.items" :key="item">{{ item }}</li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </section>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@/layouts/MainLayout.vue'
import type { AvgSection } from '@/types/pages/AvgContent.ts'
import { useHead } from '@unhead/vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, tm, locale } = useI18n()
const sections = computed(() => tm('pages.avg.sections') as AvgSection[])

useHead(() => ({
  title: t('pages.avg.seo.title'),
  meta: [{ name: 'description', content: t('pages.avg.seo.description') }],
}))
</script>
